import SolutionPageTemplate from "../components/SolutionPageTemplate";
import ecommerce from "../Accets/ecommerce.jpg";

export default function EcommerceSolutions() {
  return (
    <SolutionPageTemplate
      title="E-Commerce Solutions"
      subtitle="Empower your online business with secure payments, seller onboarding, customer verification, and automated settlements."
      image={ecommerce}

      challenges={[
        {
          title: "Complex Payment Processing",
          description:
            "Manage multiple payment methods while ensuring a seamless checkout experience.",
        },
        {
          title: "Seller Onboarding Delays",
          description:
            "Lengthy verification and onboarding reduce seller acquisition and growth.",
        },
        {
          title: "Fraud & Fake Orders",
          description:
            "Prevent fraudulent transactions and protect your customers from payment risks.",
        },
        {
          title: "Slow Settlements",
          description:
            "Delayed settlements impact cash flow and overall business operations.",
        },
      ]}

      features={[
        {
          title: "Payment Gateway",
          description:
            "Accept payments securely using cards, UPI, wallets, and net banking.",
        },
        {
          title: "Seller KYC",
          description:
            "Digitally verify merchants with fast and secure onboarding.",
        },
        {
          title: "Instant Payouts",
          description:
            "Transfer funds to sellers instantly with automated settlements.",
        },
        {
          title: "Customer Verification",
          description:
            "Verify customer identities using secure digital verification services.",
        },
        {
          title: "Refund Automation",
          description:
            "Automatically process refunds to improve customer satisfaction.",
        },
        {
          title: "Settlement APIs",
          description:
            "Manage settlements efficiently with configurable APIs.",
        },
      ]}

      benefits={[
        {
          title: "99.99% Platform Uptime",
          description:
            "Ensure uninterrupted payment processing with highly available infrastructure.",
        },
        {
          title: "Enterprise Security",
          description:
            "PCI DSS compliant systems with end-to-end encryption.",
        },
        {
          title: "24×7 Support",
          description:
            "Dedicated technical support whenever your business needs assistance.",
        },
        {
          title: "Easy API Integration",
          description:
            "Developer-friendly APIs with clear documentation for faster deployment.",
        },
      ]}

      industries={[
        "Online Retail",
        "Fashion",
        "Electronics",
        "Grocery",
      ]}

      faqs={[
        {
          question: "How long does integration take?",
          answer:
            "Most businesses can integrate within a few days using our APIs.",
        },
        {
          question: "Is the platform secure?",
          answer:
            "Yes, our infrastructure follows enterprise-grade security and compliance standards.",
        },
      ]}
    />
  );
}